import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue").then(m => m.default || m)),
  toolbox: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layers/auth-stack-oidc/layouts/toolbox.vue").then(m => m.default || m))
}